import { keyframes } from '@emotion/react';

const slideInUp = keyframes `
from {
  transform: translate3d(0, 100%, 0);
  visibility: visible;
}

to {
  transform: translate3d(0, 0, 0);
}
`;
const slideInDown = keyframes `
from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
const slideInLeft = keyframes `
 from {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
const slideInRight = keyframes `
 from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
const slideOutDown = keyframes `
from {
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  transform: translate3d(0, 100%, 0);
}
`;
const slideOutLeft = keyframes `
from {
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  transform: translate3d(-100%, 0, 0);
}
`;
const slideOutRight = keyframes `
from {
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  transform: translate3d(100%, 0, 0);
}
`;
const slideOutUp = keyframes `
 from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
`;
const fadeIn = keyframes `
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export { slideInDown as a, slideInLeft as b, slideInRight as c, slideOutUp as d, slideOutDown as e, slideOutLeft as f, slideOutRight as g, fadeIn as h, slideInUp as s };
